<template>
    <div class="column">
        <h1>{{ pageTitle }}</h1>
        <p><a href="https://fonts.google.com/specimen/Raleway" target="_blank" class="button">Download Font Files</a></p>
        <h3>Typeface</h3>
        <p><strong>Raleway</strong> is the main typeface for all paragraph and header text. We use the <em>tabluar lining</em> font-feature in all web and print designs.</p>
        <p>Below is the code needed to accomplish this font feature in CSS.</p>
        <div v-highlight >
          <pre class="language-css">
            <code>
              * {
                font-family: 'Raleway', sans-serif;
                font-variant-numeric: lining-nums;
                -moz-font-feature-settings: 'tnum';
                -webkit-font-feature-settings: 'tnum';
                font-feature-settings: 'tnum';
              }</code>
          </pre>
        </div>
        <p>&nbsp;</p>
        <h3>Sizes</h3>
        <p>Note: Subheaders are 50% of the size of headers.</p>
        <h1>H1 <small>Subheader</small></h1>
        <p>Header 1 - 48px - Raleway Black 900</p>
        <h2>H2 <small>Subheader</small></h2>
        <p>Header 2 - 40px - Raleway Black 900</p>
        <h3>H3 <small>Subheader</small></h3>
        <p>Header 3 - 32px - Raleway Black 900</p>
        <h4>H4 <small>Subheader</small></h4>
        <p>Header 4 - 24px - Raleway Black 900</p>
        <h5>H5 <small>Subheader</small></h5>
        <p>Header 5 - 20px - Raleway Black 900</p>
        <h6>H6 <small>Subheader</small></h6>
        <p>Header 6 - 18px - Raleway Black 900</p>
        <p>&nbsp;</p>
        <p>This is paragraph text. It is 18px on the web and 12pt for print. The font weight is Raleway Regular 500.</p>
        <blockquote> This is block quote text. It is 18px on the web and 12pt for print.  On ra sit eniet quam harupita voluptatus ad magnatemque et occusdae. Am iduntib usa Ga. Facient, niaspissit eici testo iduc</blockquote>
        <h3>Line Height</h3>
        <p>Web: 1.6<br>Print: 1.34 (16px for 12pt)</p>
        <h3>Spacing</h3>
        <p>Please use increments of 5px for margins and padding.</p>
    </div>
</template>

<script>
// import Color from '@/components/Color.vue'

export default {
  components: {
    // VueCodeHighlight
  },
  data () {
    return {
      pageTitle: 'Typography'
    }
  }
}
</script>

<style lang="scss">
// pre code {
//   font-size: 20px;
// }
</style>
